import ScrollReveal from 'scrollreveal';

export default ScrollReveal();



// WEBPACK FOOTER //
// ./src/js/scroll-reveal.js